



















import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

import { getModule } from 'vuex-module-decorators'

import Background from '@/components/Background.vue'
import Handles from '@/components/Handles.vue'
import SizeGetter from '@/mixins/SizeGetter.ts'

import BackgroundImage from '@/store/current/backgroundImage.ts'
const backgroundImage = getModule(BackgroundImage)

@Component({
  components: {
    Background,
    Handles
  }
})
export default class MainPanel extends mixins(SizeGetter) {
  get size (): {width: number, height: number} {
    let width = this.width
    let height = this.height
    if (width > height * this.aspectRatio) {
      width = Math.floor(height * this.aspectRatio)
    } else {
      height = Math.floor(width / this.aspectRatio)
    }
    return { width, height }
  }

  // computed
  get aspectRatio () {
    return backgroundImage.aspectRatio
  }
}
